import request from '@/utils/request'



// 查询商品档案分页
export function pageGoodsArchive(query) {
  return request({
    url: '/goods/goods/archive/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}


// 查询商品档案分页
export function pageSkuArchive(query) {
  return request({
    url: '/goods/goods/archive/sku/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}


// 查询商品档案分页
export function pageSpecArchive(query) {
  return request({
    url: '/goods/goods/archive/spec/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

